import React from "react";
import { AdvancePanel } from "../components/practices/AdvancePanel";
export default function AdvancesPage(props) { return <div className="practice-workspace" data-testid="advances-page"><AdvancePanel {...props} /></div>; }